<template>
  <div>
    <SideBar bar_name="Agent Management" :user="user"></SideBar>

    <v-main>
      <v-container>
        <Tab :tabs="tabs">
          <template v-slot="slotProps">
            <Agent v-bind="{ user: slotProps.user, tabId: slotProps.tabId, tabName: slotProps.tabName }" />
          </template>
        </Tab>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import Tab from "@/components/Tab";
import Agent from "@/components/ChangFamily/Agents/Agent";

export default {
  name: "AgentManagement",
  components: {
    SideBar,
    Tab,
    Agent
  },
  data() {
    return {
      tabs: this.$agentTabs,
      user: this.$user
    };
  }
};
</script>
